module.exports = __webpack_public_path__ + "static/OrgAnalytix-1a96180b586de938ea9257b0712a7953.jpg";